import { Directive, SimpleChanges, Input, OnChanges } from '@angular/core';
import { ProductAnalyticsService } from '@services/product-analytics/product-analytics.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[pendoTrack]',
})
export class PendoDirective implements OnChanges {
  @Input() pendoTrackEventOnShow: boolean;
  @Input() pendoTrackEvent: { name: string; data: any };

  constructor(private service: ProductAnalyticsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.pendoTrackEventOnShow?.currentValue) {
      this.handleOnShow();
    }
  }

  private handleOnShow(): void {
    this.service.sendTrackEvent(
      this.pendoTrackEvent.name,
      this.pendoTrackEvent.data
    );
  }
}
